var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCopy({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    stroke: "#DADADA",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.33268 0.666504H15.666C16.6263 0.666504 17.3327 1.37293 17.3327 2.33317V10.6665C17.3327 11.6267 16.6263 12.3332 15.666 12.3332H12.3327V15.6665C12.3327 16.6267 11.6263 17.3332 10.666 17.3332H2.33268C1.37245 17.3332 0.666016 16.6267 0.666016 15.6665V7.33317C0.666016 6.37293 1.37245 5.6665 2.33268 5.6665H5.66602V2.33317C5.66602 1.37293 6.37245 0.666504 7.33268 0.666504ZM5.66602 7.33317H2.33268V15.6665H10.666V12.3332H7.33268C6.37245 12.3332 5.66602 11.6267 5.66602 10.6665V7.33317ZM7.33268 2.33317V10.6665H15.666V2.33317H7.33268Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.892536732d889e71d7bf217e841755e8.svg";
export { ForwardRef as ReactComponent };